// An agent's status as it reads now (Fixes 9, 28 Oct): "working" said three days ago, by a run long over, is not
// working. A working status with no change for an hour, or whose run on the board has ended, reads stopped, with when
// the agent was last seen. What the agent last said is kept as it was; only how it reads changes.

import type { AgentState } from "./types";

/** How long a working status stands with no word from its agent before it reads stopped. */
export const STOPPED_AFTER = 60 * 60_000;

/** Whether an agent said it was working and has stopped since: no change in an hour, or its run on the board ended. */
export function hasStopped(a: Pick<AgentState, "status" | "updatedAt" | "ended">, now = Date.now()): boolean {
  return a.status === "working" && (a.ended === true || now - a.updatedAt >= STOPPED_AFTER);
}
